import React from 'react';
import { Typography } from 'antd';
import 'baseComponents/TextComponent/textComponent.scss';

interface Props {
  text: string;
  styleType?: 'secondary' | 'success' | 'danger' | 'warning';
  strong?: boolean;
  type?: 'paragraph' | 'span' | 'title';
  size?:
    | 'extra-small'
    | 'small'
    | 'middle'
    | 'middle-large'
    | 'large'
    | 'extra-large'
    | 'title-size'
    | 'table-title-size';
  weight?: 'extra-light' | 'extra-bold';
  opacity?: boolean;
  center?: boolean;
  inline?: boolean;
  className?: string;
}

const { Paragraph, Text, Title } = Typography;

export const TextComponent: React.FC<Props> = ({
  size = 'middle',
  ...props
}) => {
  if (props.type === 'title') {
    return (
      <Title
        className={`text-component ${props.styleType} ${props.weight} ${
          props.center && 'center'
        } ${props.inline ? 'inline' : ''} ${props.className}`}
        type={props.styleType}
      >
        {props.text}
      </Title>
    );
  }
  if (props.type === 'span') {
    return (
      <Text
        className={`text-component ${size} ${props.styleType} ${props.weight} ${
          props.opacity && 'opacity'
        } ${props.center && 'center'} ${props.inline ? 'inline' : ''} ${
          props.className
        }`}
        type={props.styleType}
        strong={props.strong}
      >
        {props.text}
      </Text>
    );
  }
  return (
    <Paragraph
      className={`text-component ${size} ${props.styleType} ${props.weight} ${
        props.opacity && 'opacity'
      } ${props.center && 'center'} ${props.inline ? 'inline' : ''} ${
        props.className
      }`}
      type={props.styleType}
      strong={props.strong}
    >
      {props.text}
    </Paragraph>
  );
};
